import React from "react";
import { useTranslation } from "react-i18next";
import {
  CheckOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Card, Col, Typography } from "antd";
import { DoubleUserIcon } from "assets/icons";

import AppButton from "components/button";
import EditorQuill from "components/inputs/editorQuill";

import { USER_TYPE } from "../../constants/appConstant";
const { Grid } = Card;

const gridHeaderStyle = {
  width: "100%",
  textAlign: "left",
  boxShadow: "none",
  padding: "20px 20px 0px 20px",
};
const gridBodyStyle = {
  width: "100%",
  textAlign: "left",
  boxShadow: "none",
  padding: "0px 20px 0px 20px",
  // maxHeight: "200px",
  maxHeight: "390px",
  overflow: "auto",
  height: "-webkit-fill-available",
};
const gridBottomStyle = {
  width: "100%",
  textAlign: "center",
  boxShadow: "none",
  padding: "10px 20px 20px",
  position: "absolute",
  bottom: 0,
};
const titleStyle = {
  marginBottom: "4px",
};
const monthlyFeeStyle = {
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "32px",
  letterSpacing: "-0.005em",
};
const monthStyle = {
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "32px",
  letterSpacing: "-0.005em",
  color: "rgba(98, 101, 118, 1)",
  marginLeft: "6px",
};
const listButtonStyle = {
  display: "flex",
  justifyContent: "space-around",
  flexWrap: "wrap",
  gap: "8px",
};

const SubscriptionCard = props => {
  const {
    item,
    onUpdate,
    onView,
    onCopy,
    onDelete,
    onSelected,
    isSelected,
    userType,
    isAdminSelect,
    isDownGrade,
    onCancelDownGrade,
    isLoading,
  } = props;
  const borderColor = isSelected
    ? "#EF5020"
    : item?.hide
    ? "#A7ADB2"
    : item?.default
    ? "#0E9154"
    : "#007bff";

  const actionStyle = {
    display: "flex",
    flex: 1,
    minWidth: "auto",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px 16px",
  };

  const cardStyle = {
    width: "100%",
    height: "100%",
    textAlign: "center",
    borderWidth: "10px 4px 4px 4px",
    borderStyle: "solid",
    borderColor: `${borderColor}`,
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    paddingBottom: "70px",
  };
  const { t } = useTranslation();
  console.log("item?.numberFee", item?.numberFee);
  return (
    <Col
      sm={{ span: 24 }}
      lg={{ span: 12 }}
      xl={{ span: 8 }}
      xxl={{ span: 6 }}
      style={{
        height: 590,
      }}
    >
      <Card style={cardStyle} className="cardFullHeight">
        <Grid style={gridHeaderStyle} hoverable={true}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <DoubleUserIcon color={borderColor} />
            <Typography.Title strong level={5}>
              {item?.name}
            </Typography.Title>
          </div>

          <div style={{ display: "flex" }}>
            <Typography style={monthlyFeeStyle}>{`${
              item?.monthlyFee !== 0
                ? "AUD" +
                  item?.monthlyFee?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                : "AUD$0"
            }`}</Typography>
            <Typography style={monthStyle}>{"/ month"}</Typography>
          </div>
        </Grid>
        <Grid
          style={gridBodyStyle}
          className="customScrollbar"
          hoverable={true}
        >
          <Typography.Paragraph style={titleStyle}>
            <CheckOutlined
              style={{ color: "green", marginRight: "8px" }}
            ></CheckOutlined>
            <span
              dangerouslySetInnerHTML={{
                __html: t(
                  item?.numberContact === 1
                    ? "subscriptions.label.includedContactNumber"
                    : item?.default
                    ? "subscriptions.label.includedContactsNumberDefault"
                    : "subscriptions.label.includedContactsNumber",
                  {
                    contact: item?.numberContact?.toLocaleString() || 0,
                  }
                ),
              }}
            ></span>
          </Typography.Paragraph>
          <Typography.Paragraph style={titleStyle}>
            <CheckOutlined
              style={{ color: "green", marginRight: "8px" }}
            ></CheckOutlined>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  item?.default && item?.numberFee === 0
                    ? t(
                        item?.numberInc === 1
                          ? "subscriptions.label.includedServiceNoCost"
                          : "subscriptions.label.includedServicesNoCost",
                        {
                          number: item?.numberInc?.toLocaleString() || 0,
                          cost:
                            "AUD" +
                              item?.numberFee?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              }) || "AUD$0",
                        }
                      )
                    : t(
                        item?.numberInc === 1
                          ? "subscriptions.label.includedServiceCost"
                          : "subscriptions.label.includedServicesCost",
                        {
                          number: item?.numberInc?.toLocaleString() || 0,
                          cost:
                            "AUD" +
                              item?.numberFee?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              }) || "AUD$0",
                        }
                      ),
              }}
            ></span>
          </Typography.Paragraph>
          <Typography.Paragraph style={titleStyle}>
            <CheckOutlined
              style={{ color: "green", marginRight: "8px" }}
            ></CheckOutlined>
            <span
              dangerouslySetInnerHTML={{
                __html:
                  item?.default && item?.perSeatFee === 0
                    ? t(
                        item?.perSeatInc === 1
                          ? "subscriptions.label.includedSeatNoCost"
                          : "subscriptions.label.includedSeatsNoCost",
                        {
                          seat: item?.perSeatInc?.toLocaleString() || 0,
                        }
                      )
                    : t(
                        item?.perSeatInc === 1
                          ? "subscriptions.label.includedSeatCost"
                          : "subscriptions.label.includedSeatsCost",
                        {
                          seat: item?.perSeatInc?.toLocaleString() || 0,
                          cost:
                            "AUD" +
                              item?.perSeatFee?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              }) || "AUD$0",
                        }
                      ),
              }}
            ></span>
          </Typography.Paragraph>

          <EditorQuill
            readOnly={true}
            customStyle={{
              whiteSpace: "initial",
              paddingLeft: "0",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
            customClassName="customScrollbar borderNone noPaddingContainer"
            value={item?.options}
          />

          <Typography.Text type="warning" italic>
            {t("subscriptions.label.allPricesAreExclusiveOfGST")}
          </Typography.Text>
        </Grid>
        <Grid style={gridBottomStyle} hoverable={true}>
          {userType === USER_TYPE.SUPER_ADMIN && !isAdminSelect && (
            <div style={listButtonStyle}>
              <AppButton
                icon={<EditOutlined />}
                varient={"outlined"}
                style={actionStyle}
                onClick={onUpdate}
                color={"blue"}
              />
              <AppButton
                icon={<EyeOutlined />}
                varient={"outlined"}
                style={actionStyle}
                onClick={onView}
                color={"blue"}
              />
              <AppButton
                icon={<CopyOutlined />}
                varient={"outlined"}
                style={actionStyle}
                onClick={onCopy}
                color={"blue"}
              />
              <AppButton
                icon={<DeleteOutlined style={{ color: "#E01839" }} />}
                varient={"outlined"}
                style={actionStyle}
                onClick={onDelete}
                disabled={item?.default}
                color={"err"}
              />
            </div>
          )}
          {userType === USER_TYPE.SUPER_ADMIN && isAdminSelect && (
            <>
              {isSelected ? (
                <AppButton
                  label={t("subscriptions.label.inUse")}
                  size={"large"}
                  style={{ width: "100%" }}
                  color={"primary"}
                  disabled={true}
                />
              ) : isDownGrade ? (
                <AppButton
                  label={t("subscriptions.label.cancelDownGrade")}
                  size={"large"}
                  style={{ width: "100%" }}
                  color={"grey"}
                  onClick={onCancelDownGrade}
                />
              ) : (
                <AppButton
                  label={t("subscriptions.label.select")}
                  size={"large"}
                  style={{ width: "100%" }}
                  color={"blue"}
                  onClick={onSelected}
                  type={"primary"}
                  loading={isLoading}
                />
              )}
            </>
          )}
          {userType === USER_TYPE.USER && (
            <>
              {isSelected ? (
                <AppButton
                  label={t("subscriptions.label.inUse")}
                  size={"large"}
                  style={{ width: "100%" }}
                  color={"primary"}
                  disabled={true}
                />
              ) : isDownGrade ? (
                <AppButton
                  label={t("subscriptions.label.cancelDownGrade")}
                  size={"large"}
                  style={{ width: "100%" }}
                  color={"grey"}
                  onClick={onCancelDownGrade}
                />
              ) : (
                <AppButton
                  label={t("subscriptions.label.select")}
                  size={"large"}
                  style={{ width: "100%" }}
                  color={"blue"}
                  onClick={onSelected}
                  type={"primary"}
                  loading={isLoading}
                />
              )}
            </>
          )}
        </Grid>
      </Card>
    </Col>
  );
};

export default SubscriptionCard;
